import React from 'react'
import { RecoilRoot } from 'recoil'

export default ({ element, props }) => {
    return (
        <RecoilRoot {...props}>{element}</RecoilRoot>
    )
}